
namespace TabAurous.ECommerce {
    import fld = ECommOrderLaborRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ECommOrderItemsDialog extends _Ext.ItemEditorDialog<ECommOrderItemsRow> {
        protected getFormKey() { return ECommOrderItemsForm.formKey; }
        protected getLocalTextPrefix() { return ECommOrderItemsRow.localTextPrefix; }
        public form = new ECommOrderItemsForm(this.idPrefix);

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        } 

        // #region Constructor
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);

            // #region UI
            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);
            // **** Assign Values to BOM and Labor Editor ****
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);

            // #endregion

            // #region Field Change Events

            this.form.Pieces.changeSelect2(e => {
                Q.Authorization
                if (this.form.Pieces.value != null) {
                    if (this.entity.ItemTypeId != 101) {
                        var pieces = parseInt(this.form.Pieces.value.toString());
                        Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                        if (parseInt(this.form.CalcOnId.value) == 3) {
                            this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                            this.form.GrossAmount.value = this.form.NetAmount.value;
                        }
                    }
                    else {
                        if (!this.form.HasBom.value)
                            Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                        else
                            Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);


                        if (parseInt(this.form.CalcOnId.value) == 3) {
                            this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                        }
                        else {
                            if (this.form.Weight.value > 0)
                                this.form.GrossAmount.value = this.form.Weight.value * this.form.NetAmount.value;
                        }
                    }
                }
            });

            this.form.Weight.changeSelect2(e => {
                if (this.form.Weight.value != undefined)
                    this.CalculateRate();
            });

            this.form.UnitRate.changeSelect2(e => {
                if (this.form.UnitRate.value != null)
                    this.CalculateRate();
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.CalcOnId.value != "")
                    this.CalculateRate();
            });

            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.entity.ItemTypeId = this.form.ItemTypeId.value;

                    this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                    this.form.CategoryId.updateItems();
                    this.form.SubCategoryId.value = "";
                    this.Setfields();
                }
            });

            this.form.UnitLabour.changeSelect2(e => {
                if (this.form.UnitLabour.value != null) {
                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;
                    if (this.form.Pieces.value != null) {
                        this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                    }
                }
            });

            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });



            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })

            this.form.SubCategoryId.changeSelect2(e => {
                if (this.form.SubCategoryId.value != "")
                    this.Setfields();
            });

            this.form.HasBom.changeSelect2(e => {
                var self = this;
                if (this.form.BOMDetails.getItems().length > 0) {
                    q.information(q.text("Message.Voucher.ReadOnly", "Are you sure?"), q.text("Message.Voucher.ReadOnlyInfo", "This will remove all components"), true, function () {
                        self.removeBOM();
                        ItemFieldHelper.PurchaseItemFields(self, self.ItemMaster.form.VoucherTypeId.value);
                    }, function () {
                        self.form.HasBom.value = true;
                    });
                } else
                    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            });

            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.KaratId.value)) {

                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity
                    }, { async: false });
                    min = purity.MinPurity;
                    max = purity.MaxPurity;
                    std = purity.StdPurity;
                    q.showAndSetRequiredField(this.form.Purity);
                    this.form.Purity.value = std;
                    this.form.Purity.value = std;
                    var date = new Date((this.parentEditor.parentDialog as ECommOrderDialog).form.TransDate.value);
                    this.form.UnitRate.value = RateHelper.GetMetalRate(parseInt(this.form.MetalId.value), parseInt(this.form.KaratId.value), false, date) / this.ExchangeRate;
                }

            });

            this.form.MetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.MetalId.value)) {
                    q.showAndSetRequiredField(this.form.KaratId);
                    this.form.KaratId.cascadeField = "Num1";
                    this.form.KaratId.cascadeValue = this.form.MetalId.value;
                }
            })

            this.form.Purity.change(e => {
                if (this.form.Purity.value != null) {
                    var current = this.form.Purity.value;
                    if (current < min || current > max) {
                        Q.alert("Enter Purity between  " + min + "  to  " + max);
                        this.form.Purity.value = this.form.Purity.value;
                    }
                    this.CalculateRate();
                }
            });

            this.form.StoneSizeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.ShapeId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.SieveId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.QualityId.changeSelect2(e => {
                this.GetRate();
            });

            this.form.StoneColorId.changeSelect2(e => {
                this.GetRate();
            });

            // #endregion

            //*** BOM row add Edit Delete Event ****

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                var LAmount = 0;
                var Wst = 0;
                for (var k of this.form.LaborDetails.getItems()) {

                    LAmount += k.LabourAmount;
                }
                this.form.UnitLabour.value = LAmount;

            });
        }

        removeBOM() {
            var item = [];
            this.form.BOMDetails.view.setItems(item, true);
        }

        getItem() {
            return this.getSaveEntity();
        }
        // #endregion

        // #region Open Dialog, Close Dialog etc

        // **** Load Entity event to set fields values ****
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.ItemMaster = (this.parentEditor.parentDialog as ECommOrderDialog);
            this.RateListId = this.ItemMaster.RateListId;
            this.LaborListId = this.ItemMaster.LaborListId;
            this.StoneMarkup = this.ItemMaster.StoneMarkup;
            this.StoneDiscount = this.ItemMaster.StoneDisount;
            this.ExchangeRate = this.ItemMaster.ExchangeRate;
            this.TransDate = this.ItemMaster.entity.TransDate;
            this.PartyId = parseInt(this.ItemMaster.form.PartyId.value);
            //this.Setfields();

            if (this.form.ProductTypeId.value == "") {
                this.form.ProductTypeId.items = this.form.ProductTypeId.items.filter(x => x.id != "5" && x.id != "6" && x.id != "7");
            }
            this.Setfields();
        } 
        // #endregion

        // #region Common Functions
        // **** Calculate Amount, Tax etc ****
        CalculateTotals() {
            if (this.form.HasBom.value) {
                var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                var labrate = 0.00; var wstper = 0; var wstwt = 0;
                for (var k of this.form.BOMDetails.getItems()) {

                    if (k.ItemTypeId == 104) {
                        Wt += k.Weight;
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                        cts += k.Weight;
                        diapcs += k.Pieces
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                        gms += k.Weight;
                        clrpcs += k.Pieces;
                    }
                    rate += k.BomAmount;
                }

                this.form.NetWeight.value = Wt;
                this.form.OtherPieces.value = othrpcs || 0;
                this.form.StonePieces.value = clrpcs || 0;
                this.form.StoneWeight.value = gms;
                this.form.DiamondPieces.value = diapcs || 0;
                this.form.DiamondWeight.value = cts || 0;
                this.form.OtherWeight.value = 0;

                if (cts > 0)
                    this.form.Weight.value = Wt + gms + (cts / 5);
                else
                    this.form.Weight.value = Wt + gms;
                this.form.UnitRate.value = rate / this.form.Pieces.value;
                this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;

                if (this.form.Pieces.value != null) {
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
                }
            }
            else if (!this.form.HasBom && this.entity.ItemTypeId == 101) {
                this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                this.form.NetWeight.value = this.entity.NetWeight;
                this.form.UnitRate.value = this.entity.UnitRate;
                this.form.NetAmount.value = this.entity.UnitRate * this.entity.Weight;
                this.form.GrossAmount.value = this.entity.UnitRate * this.entity.Weight;
            }
        }

        CalculateRate() {
            if (this.entity.ItemTypeId != 101 || this.entity.ItemTypeId == 101 && !this.entity.HasBom) {
                if (parseInt(this.form.CalcOnId.value) == 4 && this.form.UnitRate.value > 0 || parseInt(this.form.CalcOnId.value) == 5 && this.form.UnitRate.value > 0) {
                    if (this.entity.ItemTypeId == 101 && !this.entity.HasBom) {

                        this.form.PureWeight.value = this.form.Purity.value * this.form.Weight.value;
                        this.form.NetWeight.value = this.form.Weight.value;
                        let UseKaratRate = q.ToBool(TabAurous.GetConfigValue(1021));
                        if (UseKaratRate == true)
                            this.form.NetAmount.value = this.form.Weight.value * this.form.UnitRate.value;
                        else
                            this.form.NetAmount.value = this.form.Weight.value * this.form.UnitRate.value * this.form.Purity.value;
                    }
                    else {
                        this.form.NetAmount.value = this.form.Weight.value * this.form.UnitRate.value;
                    }
                    this.form.GrossAmount.value = this.form.NetAmount.value;

                }
                if (this.entity.ItemTypeId == 104) {
                    this.form.PureWeight.value = this.entity.Purity * this.form.Weight.value;
                }
            }
            else {
                Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, true);
            }

        }

        GetRate() {

            if (this.form.ItemTypeId.value == 105) {
                var rateatb: RateHelper.RateAttributes = {
                    ProductTypeId: parseInt(this.form.ProductTypeId.value),
                    CategoryId: parseInt(this.form.CategoryId.value),
                    SubCategoryId: parseInt(this.form.SubCategoryId.value),
                    ShapeId: parseInt(this.form.ShapeId.value),
                    SieveId: parseInt(this.form.SieveId.value),
                    GroupSieveId: parseInt(this.form.GroupSieveId.value),
                    StoneSizeId: parseInt(this.form.StoneSizeId.value),
                    StoneColorId: parseInt(this.form.StoneColorId.value),
                    QualityId: parseInt(this.form.QualityId.value),
                    RateListId: this.RateListId,
                    ProductId: parseInt(this.form.ProductId.value),
                    CostMethodId: this.entity.CostMethodId,
                    Weight: this.form.Weight.value
                }
                this.form.UnitRate.value = RateHelper.GetStonePurchaseRatenoAtb(rateatb);
            }

            if (this.StoneMarkup > 0)
                this.form.UnitRate.value = (this.form.UnitRate.value * (this.StoneMarkup / 100)) + this.form.UnitRate.value / this.ExchangeRate;
            if (this.StoneDiscount > 0)
                this.form.UnitRate.value = this.form.UnitRate.value - (this.form.UnitRate.value * (this.StoneMarkup / 100)) / this.ExchangeRate;

            if (this.form.UnitRate.value > 0)
                this.CalculateRate();
        }

        // **** Method to set fields as per Item Type Called from various Events ****
        private Setfields() { 
            // **** Hide Jewellery Fields **** //
            if (this.entity.ItemTypeId != 101) {
                Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                q.hideField(this.form.BOMDetails);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.ProductSizeId);
                q.hideField(this.form.UnitLabour);
                q.hideField(this.form.NetWeight);
                q.hideField(this.form.DiamondPieces);
                q.hideField(this.form.DiamondWeight);
                q.hideField(this.form.StonePieces);
                q.hideField(this.form.StoneWeight);
                q.hideField(this.form.OtherWeight);
                q.hideField(this.form.OtherPieces);
                q.hideField(this.form.WstPer);
                q.hideField(this.form.WstWt);
                //q.hideField(this.form.Line_No);
                q.hideField(this.form.SKU);
                //q.hideField(this.form.CategoryId);
                q.hideField(this.form.HasBom);
                q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName);
                this.form.HasBom.value == false;

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                    q.showAndSetRequiredField(this.form.KaratId);
                    q.showAndSetRequiredField(this.form.MetalColorId);
                    q.showAndSetRequiredField(this.form.Purity);
                    q.showAndDisableField(this.form.PureWeight);
                    this.form.CalcOnId.value = "4";
                    this.form.CalcUnitId.value = "7"

                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.StoneCutId);
                    q.hideField(this.form.StonePolishId);
                    q.hideField(this.form.StoneSymmetryId);
                    q.hideField(this.form.StoneFluorescenceId);
                    q.hideField(this.form.StoneCuletId);
                    q.hideField(this.form.StoneGirdleId);
                    q.hideField(this.form.StoneTable);
                    q.hideField(this.form.StoneDepth);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.CategoryId);

                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 104;

                    if (Q.isEmptyOrNull(this.form.CategoryId.value))
                        this.form.CategoryId.value = "0";

                    if (Q.isEmptyOrNull(this.form.SubCategoryId.value))
                        this.form.SubCategoryId.value = "0";
                }

                // **** Stone Fields **** //
                if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {

                    q.showAndSetRequiredField(this.form.QualityId);
                    q.showAndSetRequiredField(this.form.SieveId);
                    q.showAndSetRequiredField(this.form.StoneColorId);
                    q.showAndSetRequiredField(this.form.StoneSizeId);
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.MetalId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.PureWeight)
                    q.hideField(this.form.Purity);
                    this.form.CalcOnId.value = "5";
                    this.form.CalcUnitId.value = "8"

                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 105;

                    switch (parseInt(this.form.CategoryId.value)) {
                        case 1:
                        case 3:
                        case 4:
                            q.hideField(this.form.StoneCutId);
                            q.hideField(this.form.StonePolishId);
                            q.hideField(this.form.StoneSymmetryId);
                            q.hideField(this.form.StoneFluorescenceId);
                            q.hideField(this.form.StoneCuletId);
                            q.hideField(this.form.StoneGirdleId);
                            q.hideField(this.form.StoneTable);
                            q.hideField(this.form.StoneDepth);
                            q.hideField(this.form.CertificateNo);
                            //q.hideEditorCategory(this.form.StoneCuletId);
                            break;
                        case 2:
                            q.showAndSetRequiredField(this.form.StoneCutId);
                            q.showAndSetRequiredField(this.form.StonePolishId);
                            q.showAndSetRequiredField(this.form.StoneSymmetryId);
                            q.showAndSetRequiredField(this.form.StoneFluorescenceId);
                            q.showAndSetRequiredField(this.form.StoneCuletId);
                            q.showAndSetRequiredField(this.form.StoneGirdleId);
                            q.showAndSetRequiredField(this.form.StoneTable);
                            q.showAndSetRequiredField(this.form.StoneDepth);
                            q.showAndSetRequiredField(this.form.CertificateNo);
                            q.showAndSetRequiredField(this.form.Pieces);
                            q.showAndSetRequiredField(this.form.Weight);
                            q.showAndSetRequiredField(this.form.Lab);

                            break;
                    }
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ShapeId) : q.showAndSetRequiredField(this.form.ShapeId);
                }
            }
            else {
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CategoryId) : q.showAndSetRequiredField(this.form.CategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.BrandId) : q.showAndSetRequiredField(this.form.BrandId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CollectionId) : q.showAndSetRequiredField(this.form.CollectionId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SuperTypeId) : q.showAndSetRequiredField(this.form.SuperTypeId);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductSizeId) : q.showAndSetRequiredField(this.form.ProductSizeId);
                //this.entity.ProductId > 0 ? this.form.HasBom.value == true ? q.showAndDisableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);
                this.entity.ProductId > 0 ? q.showAndDisableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);

                this.form.HasBom.value == true ? q.showFieldAndCategory(this.form.BOMDetails) : q.showFieldAndCategory(this.form.BOMDetails, false);
                this.form.HasBom.value == true ? q.hideField(this.form.Purity) : parseInt(this.form.KaratId.value) > 0 ? q.showAndSetRequiredField(this.form.Purity) : q.showAndDisableField(this.form.Purity);
                this.form.HasBom.value == true ? q.hideField(this.form.PureWeight) : q.showAndDisableField(this.form.PureWeight);
                //this.form.HasBom.value == true ? q.hideField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);
                this.form.HasBom.value == true ? q.showAndDisableField(this.form.Weight) : q.showAndEnableField(this.form.Weight);
                //this.form.HasBom.value == true ? q.hideEditorTab(this.form.BOMDetails, false) : q.hideEditorTab(this.form.BOMDetails);
                this.form.HasBom.value == true ? this.form.CalcOnId.value = "3" : this.form.CalcOnId.value = "4";
                this.form.HasBom.value == true ? this.form.CalcUnitId.value = "6" : this.form.CalcUnitId.value = "7";
                this.form.HasBom.value == true ? q.hideField(this.form.MetalId) : this.entity.ProductId > 0 ? q.showAndDisableField(this.form.MetalId) : q.showAndSetRequiredField(this.form.MetalId);
                this.form.HasBom.value == true ? q.hideField(this.form.KaratId) : parseInt(this.form.MetalId.value) > 0 ? q.showAndSetRequiredField(this.form.KaratId) : q.showAndDisableField(this.form.KaratId);
                this.form.HasBom.value == false ? parseInt(this.form.KaratId.value) > 0 ? q.showAndSetRequiredField(this.form.UnitRate) : q.showAndDisableField(this.form.UnitRate) : q.showAndDisableField(this.form.UnitRate);


                if (!this.form.HasBom.value) {
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                    q.HideCategoryLable(this.element)
                }
                //q.showAndDisableField(this.form.Line_No);
                q.hideEditorTab(this.form.BOMDetails, false);
                q.hideEditorTab(this.form.ImageName, false);
                q.showAndDisableField(this.form.UnitLabour);
                q.showAndDisableField(this.form.NetWeight);
                q.showAndDisableField(this.form.DiamondPieces);
                q.showAndDisableField(this.form.DiamondWeight);
                q.showAndDisableField(this.form.StonePieces);
                q.showAndDisableField(this.form.StoneWeight);
                q.showAndDisableField(this.form.OtherWeight);
                q.showAndDisableField(this.form.OtherPieces);
                q.showAndDisableField(this.form.WstPer);
                q.showAndDisableField(this.form.WstWt);
                q.hideField(this.form.MetalColorId);
                q.hideField(this.form.ShapeId);
                q.hideField(this.form.QualityId);
                q.hideField(this.form.StoneColorId);
                q.hideField(this.form.StoneSizeId);
                q.hideField(this.form.SieveId);
                q.hideField(this.form.StoneCutId);
                q.hideField(this.form.StonePolishId);
                q.hideField(this.form.StoneSymmetryId);
                q.hideField(this.form.StoneFluorescenceId);
                q.hideField(this.form.StoneCuletId);
                q.hideField(this.form.StoneGirdleId);
                q.hideField(this.form.StoneTable);
                q.hideField(this.form.StoneDepth);
                q.showAndEnableField(this.form.CertificateNo);
                q.showAndEnableField(this.form.Lab);

                if (this.form.IsConfigurable.value) {
                    q.showAndSetRequiredField(this.form.SKU);
                }
            }

            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductCode) : q.showAndSetRequiredField(this.form.ProductCode);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductName) : q.showAndSetRequiredField(this.form.ProductName);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.ProductTypeId) : q.showAndSetRequiredField(this.form.ProductTypeId);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CalcOnId) : q.showAndSetRequiredField(this.form.CalcOnId);
            this.entity.ProductId > 0 ? q.showAndDisableField(this.form.CalcUnitId) : q.showAndSetRequiredField(this.form.CalcUnitId);


        }

        // #endregion 


        protected validateBeforeSave() {
            this.form.AttributeId.value = "0";
            var t = this.RateListId;
            this.entity.RefTransId == null? this.entity.RefTransId = 0 : this.entity.RefTransId = this.entity.RefTransId
            this.entity.RefTransItemId == null? this.entity.RefTransItemId = 0 : this.entity.RefTransItemId = this.entity.RefTransItemId 
            this.entity.RefVoucherId == null? this.entity.RefVoucherId = 0 : this.entity.RefVoucherId = this.entity.RefVoucherId
            this.entity.Studded == null? this.entity.Studded = 0 : this.entity.Studded = this.entity.Studded
            this.entity.MetalAmount == null? this.entity.MetalAmount = 0 : this.entity.MetalAmount = this.entity.MetalAmount
            this.entity.DiamondAmount == null? this.entity.DiamondAmount = 0 : this.entity.DiamondAmount = this.entity.DiamondAmount
            this.entity.StoneAmount == null? this.entity.StoneAmount = 0 : this.entity.StoneAmount = this.entity.StoneAmount

            if (this.form.Line_No.value == "")
                Purchase.PurchaseMasterService.GetLineNo({}, response => this.form.Line_No.value = response.Line_No.toString(), {
                    async: false
                });
            if (this.form.ItemTypeId.value == 101) {
                if (this.form.HasBom.value) {
                    let items = this.form.BOMDetails.getItems();
                    let count = 0;
                    if (items.length > 0) {

                        items.forEach(function (x) {
                            if (x.ItemTypeId == 104)
                                count++
                        });

                        if (count == 0) {
                            q.Warning("Can not Save!", "Metal details not defined", false);
                            return false;
                        }
                        else
                            return true;
                    }
                    else {
                        q.Warning("Can not Save!", "Components or BOM is not defined", false);
                        return false;

                    }
                }

            }
            else {
                this.entity.Studded = 1;
            }

            if (this.form.Weight.value == 0) {
                q.Warning("Can not Save!", "Weight is undefined or 0", false);
                return false;
            }
            else {
                return true;
            }
        } 
    }
}